var render, staticRenderFns
import script from "./vuePdfNoSss.vue?vue&type=script&lang=js&"
export * from "./vuePdfNoSss.vue?vue&type=script&lang=js&"
import style0 from "./annotationLayer.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports